import TemplateForm from "./TemplateForm.component";

export default TemplateForm;
